import React from 'react'
import { useState } from 'react'
import '../projects.css'
import {projectsCgiData} from '../../../data'
import {LiaWindowClose} from 'react-icons/lia'
import Footer from '../../../components/Footer'
import ContactUs from '../../../components/ContactUs'
import '../../home/home.css'

const ProjectsConfigurators = () => {
  const [isMovieShowing, setIsMovieShowing] = useState(false);
  const [Movie, setMovie] = useState(null);
  const [MWidth, setMWidth] = useState(0);
  const [MHeight, setMHeight] = useState(0);

  /*=============== SHOW DROPDOWN MENU ===============*/
const movieEvent = (path, mwidth, mheight) => {

  if (!isMovieShowing) {

    const movie__item = document.querySelector('.movie__item')

    setMWidth(mwidth)

    setMHeight(mheight)

    toggleItem(movie__item, path)
  }
}

const toggleItem = (item, path) =>{

  const movieWrapper = item.querySelector('.movie__wrapper')

  if(item.classList.contains('show-movie-item')) {

    item.classList.remove('show-movie-item')

    movieWrapper.classList.remove('show-movie__wrapper')

    item.classList.add('hide-movie-item')

    movieWrapper.classList.add('hide-movie__wrapper')

    setIsMovieShowing(false)

    setMovie(null)

  } else {

    if(item.classList.contains('hide-movie-item')) {

      item.classList.remove('hide-movie-item')
    }

    item.classList.add('show-movie-item')

    if(movieWrapper.classList.contains('hide-movie__wrapper')) {

      movieWrapper.classList.remove('hide-movie__wrapper')
    }

    setMovie(path)

    movieWrapper.classList.add('show-movie__wrapper')

    setIsMovieShowing(true)
  }
}

const closeMenu = () => {

  const showMovie = document.querySelector('.show-movie-item')

  if(showMovie) {

      toggleItem(showMovie)
  }
}
  return (
    <section className='project'>
      <div className='project__container'>
        <div className='project__layoutcontainer'>
          <h1>CGI Projects</h1>
          <div className='project__flexcontainer'>
          {
                projectsCgiData.map(({index, name, title, description, movie, image, mwidth, mheight}) => {
                  return (
                    <li className='project_card' key={index} style={{backgroundImage: `url(${image})`, backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat'}}>
                            <div className="project-content-container" >
                                <div className="project-center-content">
                                    <p>USECASES</p>
                                    <h2>PROJECTS</h2>
                                    <p>{title}</p>
                                    <h3>{name}</h3>
                                    <p>{description}</p>
                                    <a className='trans_btn md' onClick={() => movieEvent(movie, mwidth, mheight)}>WATCH CASE</a>
                                </div>
                            </div>
                    </li>
                  )
                })
              }
          </div>
          <div className='movie__item' onClick={() => closeMenu()}>
            <div className='movie__container'>
              <div className='movie__inner-container'>
                <div className='movie__wrapper'>
                  <LiaWindowClose className='video-close-btn' />
                  <iframe className='video-iframe' width={MWidth} height={MHeight} src={Movie} type="video/mp4" frameBorder='0' autoPlay encrypted-media gyroscope controls></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ContactUs/>
      <Footer/>
    </section>
  )
}

export default ProjectsConfigurators